import { render, staticRenderFns } from "./NoDataFoundAlert.vue?vue&type=template&id=6fce7120&"
import script from "./NoDataFoundAlert.vue?vue&type=script&lang=js&"
export * from "./NoDataFoundAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports